import { lookupService } from '../../helpers/services/lookup.service';
import i18n from '@/i18n'
import { sharedHelper, sessionHelper } from '@/utils'

export const state = {
  roleDdl: [],
  permissionDdl: [],
  userDdl: [],
  companySizeDdl: [],
  locationDdl: [],
  companyDdl: [],
  companyTypeDdl: [],
  ownPackageDdl: [],
  ownServiceDdl: [],
  ownCompanyLocationDdl: [],
  ownCompanyMenuDdl: [],
  ownCheckPointDdl: [],
  labelDdl: [],
  reportDdl: [],
  paymentMethodDdl: [],
  taxDdl: [],
  modelDdl: [],
  serviceTemplateDdl: [],

  //new 
  publicCompanyDdl: []
};

export const LOOKUP_MODULE = "lookup";

// define action 
export const LOOKUP_ROLE = 'lookupRole';
export const LOOKUP_PERMISSION = 'lookupPermission';
export const LOOKUP_USER = 'lookupUser';
export const LOOKUP_COMPANY_SIZE = 'lookupCompanySize';
export const LOOKUP_LOCATIONS = 'lookupLocation';
export const LOOKUP_COMPANY = 'lookupCompany';
export const LOOKUP_COMPANY_TYPE = 'lookupCompanyType';
export const LOOKUP_OWN_PACKAGE = 'lookupOwnPackage';
export const LOOKUP_OWN_SERVICE = 'lookupOwnService';
export const LOOKUP_OWN_COMPANY_LOCATION = 'lookupOwnCompanyLocation';
export const LOOKUP_OWN_COMPANY_MENU = 'lookupOwnCompanyMenu';
export const LOOKUP_OWN_CHECK_POINT = 'lookupOwnCheckPoint';
export const LOOKUP_LABEL = 'lookupLabel';
export const LOOKUP_REPORT = 'lookupReport';
export const LOOKUP_PAYMENT_METHOD = 'lookupPaymentMethod';
export const LOOKUP_TAX = 'lookupTax';
export const LOOKUP_PUBLIC_PAYMENT_METHOD = 'lookupPublicPaymentMethod';
export const LOOKUP_VEHICLE_MODEL = 'lookupVehicleModel';
export const LOOKUP_SERVICE_TEMPLATE = 'lookupServiceTemplate';
export const LOOKUP_PUBLIC_COMPANY = 'lookupPublicCompany';

// define mutation
const ROLE_LOOKUP = "roleLookup";
const PERMISSION_LOOKUP = "permissionLookup";
const USER_LOOKUP = "userLookup";
const COMPANY_SIZE_LOOKUP = "companySizeLookup";
const LOCATION_LOOKUP = "locationLookup";
const COMPANY_LOOKUP = "companyLookup";
const COMPANY_TYPE_LOOKUP = "companyTypeLookup";
const OWN_PACKAGE_LOOKUP = "ownPackageLookup";
const OWN_SERVICE_LOOKUP = "ownServiceLookup";
const OWN_COMPANY_LOCATION_LOOKUP = "ownCompanyLocationLookup";
const OWN_COMPANY_LOCATION_LOOKUP_STAFF = "ownCompanyLocationLookupStaff";
const OWN_COMPANY_MENU_LOOKUP = "ownCompanyMenuLookup";
const OWN_CHECK_POINT_LOOKUP = "ownCheckPointLookup";
const LABEL_LOOKUP = "labelLookup";
const REPORT_LOOKUP = "reportLookup";
const PAYMENT_METHOD_LOOKUP = "paymentMethodLookup";
const TAX_LOOKUP = "taxLookup";
const VEHICLE_MODEL_LOOKUP = "vehicleModelLookup";
const SERVICE_TEMPLATE_LOOKUP = "serviceTemplateLookup";
const PUBLIC_COMPANY_LOOKUP = "publicCompanyLookup";

export const mutations = {

  [ROLE_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.roleDdl = p
    } else {
      state.roleDdl = []
    }
  },

  [LABEL_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.labelDdl = p
    } else {
      state.labelDdl = []
    }
  },

  [OWN_COMPANY_LOCATION_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name,
          url: x.url
        })
      })

      state.ownCompanyLocationDdl = p
    } else {
      state.ownCompanyLocationDdl = []
    }
  },


  [OWN_COMPANY_LOCATION_LOOKUP_STAFF](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name,
          url: x.url,
          companyName: x.company_name,
          companyUUID: x.company_uuid
        })
      })

      state.ownCompanyLocationDdl = p
    } else {
      state.ownCompanyLocationDdl = []
    }
  },

  [OWN_CHECK_POINT_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.ownCheckPointDdl = p
    } else {
      state.ownCheckPointDdl = []
    }
  },

  [VEHICLE_MODEL_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.modelDdl = p
    } else {
      state.modelDdl = []
    }
  },

  [COMPANY_SIZE_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.companySizeDdl = p
    } else {
      state.companySizeDdl = []
    }
  },

  [USER_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.userDdl = p
    } else {
      state.userDdl = []
    }
  },

  [LOCATION_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.locationDdl = p
    } else {
      state.locationDdl = []
    }
  },

  [COMPANY_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.companyDdl = p
    } else {
      state.companyDdl = []
    }
  },


  [COMPANY_TYPE_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.companyTypeDdl = p
    } else {
      state.companyTypeDdl = []
    }
  },


  [OWN_PACKAGE_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.ownPackageDdl = p
    } else {
      state.ownPackageDdl = []
    }
  },

  [OWN_COMPANY_MENU_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.ownCompanyMenuDdl = p
    } else {
      state.ownCompanyMenuDdl = []
    }
  },


  [OWN_SERVICE_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.ownServiceDdl = p
    } else {
      state.ownServiceDdl = []
    }
  },


  [PAYMENT_METHOD_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name,
          image: x.image
        })
      })

      state.paymentMethodDdl = p
    } else {
      state.paymentMethodDdl = []
    }
  },


  [TAX_LOOKUP](state, { data }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name, 
          percentage: x.percentage
        })
      })

      state.taxDdl = p
    } else {
      state.taxDdl = []
    }
  },


  // eslint-disable-next-line no-unused-vars
  [PERMISSION_LOOKUP](state, { data, hasOptionAll }) {

    function getCodeAndLabelFromPermission(permission) {
      return {
        code: permission.code,
        label: i18n.t(`permissions.${permission.code}`)
      }
    }

    state.permissionDdl = data.data.map((permissionModule) => {
      return {
        module: permissionModule.module,
        submodule: permissionModule.submodule,
        permissions: permissionModule.permissions.map(getCodeAndLabelFromPermission)
      }
    })
  },

  // eslint-disable-next-line no-unused-vars
  [REPORT_LOOKUP](state, { data, hasOptionAll }) {

    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.reference_number
        })
      })

      state.reportDdl = p
    } else {
      state.reportDdl = []
    }
  },

  // eslint-disable-next-line no-unused-vars
  [SERVICE_TEMPLATE_LOOKUP](state, { data, hasOptionAll }) {
    let p = []
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.uuid,
          text: x.name
        })
      })

      state.serviceTemplateDdl = p
    } else {
      state.serviceTemplateDdl = []
    }

  },

   // eslint-disable-next-line no-unused-vars
  [PUBLIC_COMPANY_LOOKUP](state, { data, hasOptionAll }) {
    let p = [
       { value: null, text: "All Companies" },
    ]
    let response = data

    if (response.success) {
      response.data.forEach((x) => {
        p.push({
          value: x.value,
          text: x.name
        })
      })
      state.publicCompanyDdl = p
    } else {
      state.publicCompanyDdl = []
    }

  },

  modulePermissionLookup(state, { data }) {

    function getCodeAndLabelFromPermission(permission) {
      return {
        code: permission.code,
        label: i18n.t(`permissions.${permission.code}`)
      }
    }

    state.permissionDdl = data.data.map((permissionModule) => {
      return {
        module: permissionModule.module,
        submodule: permissionModule.submodule,
        permissions: permissionModule.permissions.map(getCodeAndLabelFromPermission)
      }
    })
  },


};

export const actions = {

  [LOOKUP_ROLE]({ commit }, { hasOptionAll }) {
    lookupService.getLookupRoles().then(
      (data) => {
        commit(ROLE_LOOKUP, { data })
      },
      (error) => {
        let message = 'Role Lookup' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(ROLE_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_LABEL]({ commit }, { hasOptionAll }) {
    lookupService.getLookupLabels().then(
      (data) => {
        commit(LABEL_LOOKUP, { data })
      },
      (error) => {
        let message = 'Label Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(LABEL_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_PERMISSION]({ commit }, { hasOptionAll }) {
    lookupService.getAllModulePermissions().then(
      (data) => {
        commit(PERMISSION_LOOKUP, { data, hasOptionAll })
      },
      (error) => {
        let message = 'Permission Lookup' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(PERMISSION_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_OWN_CHECK_POINT]({ commit }, { hasOptionAll }) {
    lookupService.getOwnCheckPoints().then(
      (data) => {
        commit(OWN_CHECK_POINT_LOOKUP, { data, hasOptionAll })
      },
      (error) => {
        let message = 'Check Point Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(OWN_CHECK_POINT_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_USER]({ commit }, { hasOptionAll }) {
    lookupService.getLookupUsers().then(
      (data) => {
        commit(USER_LOOKUP, { data })
      },
      (error) => {
        let message = 'User Lookup' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(USER_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_COMPANY_SIZE]({ commit }, { hasOptionAll }) {
    lookupService.getAllCompanySizes().then(
      (data) => {
        commit(COMPANY_SIZE_LOOKUP, { data })
      },
      (error) => {
        let message = 'Company Size Lookup' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(COMPANY_SIZE_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_LOCATIONS]({ commit }, { hasOptionAll }) {
    lookupService.getAllLocations().then(
      (data) => {
        commit(LOCATION_LOOKUP, { data })
      },
      (error) => {
        let message = 'Location Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(LOCATION_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_COMPANY]({ commit }, { hasOptionAll }) {
    lookupService.getAllCompanies().then(
      (data) => {
        commit(COMPANY_LOOKUP, { data })
      },
      (error) => {
        let message = 'Company Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(COMPANY_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_COMPANY_TYPE]({ commit }, { hasOptionAll }) {
    lookupService.getAllCompanyTypes().then(
      (data) => {
        commit(COMPANY_TYPE_LOOKUP, { data })
      },
      (error) => {
        let message = 'Company Type Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(COMPANY_TYPE_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  async [LOOKUP_OWN_PACKAGE]({ commit }, { hasOptionAll }) {
    await lookupService.getOwnPackages().then(
      (data) => {
        commit(OWN_PACKAGE_LOOKUP, { data })
      },
      (error) => {
        let message = 'Own Package Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(OWN_PACKAGE_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_OWN_SERVICE]({ commit }, { hasOptionAll }) {
    lookupService.getOwnServices().then(
      (data) => {
        commit(OWN_SERVICE_LOOKUP, { data })
      },
      (error) => {
        let message = 'Own Service Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(OWN_SERVICE_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_OWN_COMPANY_LOCATION]({ commit }, { hasOptionAll }) {
    lookupService.getOwnCompanyLocations().then(
      (data) => {
        if(sessionHelper.getUserType() == "ADMIN") {
          commit(OWN_COMPANY_LOCATION_LOOKUP, { data })
        }
        else {
          commit(OWN_COMPANY_LOCATION_LOOKUP_STAFF, { data })
        }
      },
      (error) => {
        let message = 'Own Company Location Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(OWN_COMPANY_LOCATION_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_OWN_COMPANY_MENU]({ commit }, { hasOptionAll }) {
    lookupService.getOwnCompanyMenus().then(
      (data) => {
        commit(OWN_COMPANY_MENU_LOOKUP, { data })
      },
      (error) => {
        let message = 'Own Company Menu Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(OWN_COMPANY_MENU_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_REPORT]({ commit }, { hasOptionAll }) {
    lookupService.getLookupReports().then(
      (data) => {
        commit(REPORT_LOOKUP, { data })
      },
      (error) => {
        let message = 'Report Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(REPORT_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_PAYMENT_METHOD]({ commit }, { hasOptionAll }) {
    lookupService.getLookupPaymentMethods().then(
      (data) => {
        commit(PAYMENT_METHOD_LOOKUP, { data })
      },
      (error) => {
        let message = 'Payment Method Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(PAYMENT_METHOD_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_TAX]({ commit }, { hasOptionAll }) {
    lookupService.getLookupTaxes().then(
      (data) => {
        commit(TAX_LOOKUP, { data })
      },
      (error) => {
        let message = 'Tax Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(TAX_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_PUBLIC_PAYMENT_METHOD]({ commit }, { hasOptionAll }) {
    lookupService.getLookupPublicPaymentMethods().then(
      (data) => {
        commit(PAYMENT_METHOD_LOOKUP, { data })
      },
      (error) => {
        let message = 'Public Payment Method Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(PAYMENT_METHOD_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_VEHICLE_MODEL]({ commit }, { hasOptionAll }) {
    lookupService.getLookupVehicleModel().then(
      (data) => {
        commit(VEHICLE_MODEL_LOOKUP, { data })
      },
      (error) => {
        let message = 'Vehicle Model Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(VEHICLE_MODEL_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  [LOOKUP_SERVICE_TEMPLATE]({ commit }, { hasOptionAll }) {
    lookupService.getLookupServiceTemplates().then(
      (data) => {
        commit(SERVICE_TEMPLATE_LOOKUP, { data })
      },
      (error) => {
        let message = 'Service Template Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(SERVICE_TEMPLATE_LOOKUP, { error, hasOptionAll })
      }
    )
  },

   [LOOKUP_PUBLIC_COMPANY]({ commit }, { hasOptionAll }) {
    lookupService.getPublicCompany().then(
      (data) => {
        commit(PUBLIC_COMPANY_LOOKUP, { data })
      },
      (error) => {
        let message = 'Public Company Lookup ' + sharedHelper.getErrorMessage(error);
        sharedHelper.alertErrorMessage(message, error.response.data.code)
        commit(PUBLIC_COMPANY_LOOKUP, { error, hasOptionAll })
      }
    )
  },

  // eslint-disable-next-line no-unused-vars
  getPermissionModuleLookup({ commit, dispatch }, { hasOptionAll }) {
    lookupService.getAllModulePermissions().then(
      (data) => {
        commit('modulePermissionLookup', { data, hasOptionAll })
      },
      (error) => {
        commit('modulePermissionLookup', { error, hasOptionAll })
      }
    )
  },
};
